function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from '../../util';
import EditUserAccessModal from './EditUserAccessModal';
import claimGroupService from '../../services/claim_group.service';
import userAccessService from '../../services/user_access.service';
import UserAccessProjectBadges from './UserAccessProjectBadges';
import UserAccessBusinessUnitBadges from './UserAccessBusinessUnitBadges';
import { PROJECT_OVERVIEW_ALL_CONTACTS_MAX_AMOUNT_OF_PROJECT_BADGES } from '@rd-web-markets/market/dist/constants';
const AllContactsTab = _ref => {
  var _claimGroup$user_acce;
  let {
    claimGroup,
    setClaimGroup,
    company,
    claimGroupStepAccess,
    setEngagementTeam
  } = _ref;
  const {
    t
  } = useTranslation();
  const [userAccessToEdit, setUserAccessToEdit] = useState(null);
  const [editModalShow, setEditModalShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const onSubmit = async userAccess => {
    const updatedUserAccess = await userAccessService.update(claimGroup.id, userAccess);
    const updatedClaimGroup = await claimGroupService.get(claimGroup.id);
    setClaimGroup(updatedClaimGroup);
    if (updatedUserAccess.included_in_engagement_team) {
      setEngagementTeam(prev => {
        if (!prev) return {
          clients: [],
          accountants: []
        };
        const isAccountant = updatedUserAccess.roles.includes('accountant');
        const arrayKey = isAccountant ? 'accountants' : 'clients';
        const updatedArray = [...(prev[arrayKey] || [])];
        const newEntry = _objectSpread(_objectSpread({}, updatedUserAccess.user), {}, {
          user_access: _objectSpread({}, updatedUserAccess)
        });
        const index = updatedArray.findIndex(e => e.user_access.id === updatedUserAccess.id);
        if (index >= 0) {
          updatedArray[index] = newEntry;
        } else {
          updatedArray.push(newEntry);
        }
        return _objectSpread(_objectSpread({}, prev), {}, {
          [arrayKey]: updatedArray
        });
      });
    }
  };
  const headers = [{
    text: t('name'),
    filterableByText: true,
    sortable: true,
    valueFnForSortAndFilter: r => r.data.object.user.name || '',
    width: '350px'
  }, {
    text: t('role'),
    filterableByText: true,
    sortable: true,
    valueFnForSortAndFilter: r => r.data.object.user.role || '',
    width: '300px'
  }, {
    text: t('business_unit'),
    filterableByText: true,
    valueFnForSortAndFilter: r => r.data.object.user_access_business_unit_participations.map(p => p.business_unit.name).join(' ') || '',
    width: '350px'
  }, {
    text: t('projects'),
    filterableByText: true,
    sortable: false,
    valueFnForSortAndFilter: r => r.data.object.user_access_project_participations.map(p => p.claim_project_report.project_name).join(' ') || '',
    width: '370px'
  }, {
    text: t('email'),
    filterableByText: true,
    sortable: true,
    valueFnForSortAndFilter: r => r.data.object.user.email || '',
    width: '300px'
  }, {
    text: t('phone'),
    filterableByText: true,
    sortable: true,
    valueFnForSortAndFilter: r => r.data.object.user.phone_number || '',
    width: '300px'
  }];
  const onEdit = useCallback((rowIndex, row) => {
    const userAccess = row.data.object;
    setUserAccessToEdit(userAccess);
    setEditModalShow(true);
  }, []);
  const deleteUserClaimGroupAccess = userAccessService.useDeleteUserAccess(claimGroup, setClaimGroup, setLoading);
  const onDelete = useCallback((rowIndex, row) => {
    const userAccess = row.data.object;
    deleteUserClaimGroupAccess(userAccess.id);
  }, [deleteUserClaimGroupAccess]);
  console.log('All contacts tab - claim group user accesses:', claimGroup.user_accesses);
  const rows = (_claimGroup$user_acce = claimGroup.user_accesses) === null || _claimGroup$user_acce === void 0 ? void 0 : _claimGroup$user_acce.filter(userAccess => userAccess.included_in_engagement_team !== true).map(userAccess => {
    var _userAccess$user, _userAccess$user2, _userAccess$user3;
    return {
      key: userAccess.id,
      data: {
        object: userAccess
      },
      columns: [(_userAccess$user = userAccess.user) === null || _userAccess$user === void 0 ? void 0 : _userAccess$user.name, userAccess.roles.map(role => t(role)).join(', '), /*#__PURE__*/React.createElement(UserAccessBusinessUnitBadges, {
        userAccess: userAccess
      }), /*#__PURE__*/React.createElement(UserAccessProjectBadges, {
        userAccess: userAccess,
        maxAmountOfBadges: PROJECT_OVERVIEW_ALL_CONTACTS_MAX_AMOUNT_OF_PROJECT_BADGES
      }), (_userAccess$user2 = userAccess.user) === null || _userAccess$user2 === void 0 ? void 0 : _userAccess$user2.email, (_userAccess$user3 = userAccess.user) === null || _userAccess$user3 === void 0 ? void 0 : _userAccess$user3.phone_number]
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, userAccessToEdit && /*#__PURE__*/React.createElement(EditUserAccessModal, {
    company: company,
    claimGroup: claimGroup,
    setClaimGroup: setClaimGroup,
    title: t('edit_contact'),
    onHide: () => setEditModalShow(false),
    show: editModalShow,
    userAccess: userAccessToEdit,
    onSubmit: onSubmit
  }), /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows,
    onEdit: claimGroupStepAccess.canEditAnyTypeOfUser ? onEdit : null,
    onDelete: claimGroupStepAccess.canEditAnyTypeOfUser ? onDelete : null
  }));
};
export default AllContactsTab;